import React, { useEffect, useState } from "react";
import { gridColumns_ReservesLoanDetails } from "../../Utils/TableColumnDefs";
import CommonGrid from "../CommonGrid";
import axios from "../../axios";
import urls from "../../Utils/urls";
import { SpinnerBlock } from "../../Utils/CustomComponent";
import { useAbortController } from "../../hooks/useAbortController";

const ImpoundsLoanDetailsTable = ({ className = "", loanId }) => {
  const [tableData, setTableData] = useState();
  const { signal } = useAbortController();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(urls.loanDetails.getImpounds(loanId), {
          signal,
        });
        const data = res.data[0];
        const sortedData = data?.sort(
          (a, b) => new Date(b.Date) - new Date(a.Date),
        );
        setTableData(sortedData);
      } catch (error) {
        if (error.name === "CanceledError") {
          console.error("Fetch request canceled", error.message);
        } else {
          // console.error(error);
          console.error("Error fetching data:", error);
        }
      }
    };
    fetchData();
  }, []);

  return (
    <>
      {tableData ? (
        <CommonGrid
          className={`col-sm-12 ${className}`}
          title={"Impounds"}
          gridColumns={gridColumns_ReservesLoanDetails}
          columnData={tableData}
        />
      ) : (
        <SpinnerBlock />
      )}
    </>
  );
};

export default ImpoundsLoanDetailsTable;
